import { render, staticRenderFns } from "./FrameworkMap.vue?vue&type=template&id=2529f9ba"
import script from "./FrameworkMap.vue?vue&type=script&lang=js"
export * from "./FrameworkMap.vue?vue&type=script&lang=js"
import style0 from "./FrameworkMap.vue?vue&type=style&index=0&id=2529f9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
